/**
 * Wire constants shared by the SSO gates. Kept dependency-free so the
 * middleware gate (lib/sso/middleware-gate.ts) can use them without pulling
 * the Prisma-backed decision or `next/navigation` into the middleware graph.
 */

/** Where a blocked browser is sent — the page the app layout redirects to. */
export const SSO_REQUIRED_PATH = "/sso-required";

/** The wire error `requireAuth()` returns for an SSO-blocked session. */
export const SSO_REQUIRED_ERROR = "sso_required";

/** Stable mobile API detail for an SSO-policy refusal; role/plan denials omit it. */
export const SSO_REQUIRED_DETAIL_REASON = "SSO_REQUIRED" as const;
export type SsoRequiredErrorDetails = {
  reason: typeof SSO_REQUIRED_DETAIL_REASON;
};
